import { IconButton, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ConfirmSelectionButton, SelectionPageHeader } from '../../../common/components';
import type { Product } from '../../../../types/product';

interface SingleProductSelectionHeaderProps {
  companyId: number;
  returnPath?: string;
  showFilters: boolean;
  onToggleFilters: () => void;
  selectedProduct: Product | null;
  onConfirmSelection: () => void;
  hasActiveFilters: boolean;
}

export const SingleProductSelectionHeader = ({
  companyId,
  returnPath,
  showFilters,
  onToggleFilters,
  selectedProduct,
  onConfirmSelection,
  hasActiveFilters,
}: SingleProductSelectionHeaderProps) => {
  return (
    <SelectionPageHeader
      title="Вибір продукту"
      companyId={companyId}
      returnPath={returnPath}
    >
      <Tooltip title="Показати/сховати фільтри">
        <IconButton
          size="small"
          onClick={onToggleFilters}
          color={showFilters || hasActiveFilters ? 'primary' : 'default'}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>

      {selectedProduct && <ConfirmSelectionButton onClick={onConfirmSelection} />}
    </SelectionPageHeader>
  );
};
